import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { ContractsPromise } from "queries/contract_manager";
import { PRODUCT_DISPLAY_NAMES } from "utils/constants";
import {
  capitaliseProductName,
  normaliseProductName,
} from "utils/productNameUtils";

const currentProductSlice = createSlice({
  name: "currentProduct",
  initialState: {
    contractName: undefined,
    description: undefined,
    displayName: undefined,
    id: undefined,
    endsAt: undefined,
    isCurrentProductError: false,
    normalisedName: undefined,
  },
  reducers: {
    setCurrentProduct: (
      state,
      action: PayloadAction<{ contractData?: ContractsPromise }>,
    ) => {
      const { contractData = undefined } = action.payload;

      const normalisedName = contractData?.name
        ? normaliseProductName(contractData.name)
        : undefined;

      const displayName = normalisedName
        ? capitaliseProductName(PRODUCT_DISPLAY_NAMES[normalisedName])
        : undefined;

      state.contractName = contractData?.contractName || false;
      state.description = contractData?.description || undefined;
      state.displayName = displayName;
      state.endsAt = contractData?.endsAt;
      state.id = contractData?.id;
      state.normalisedName = normalisedName;
    },
    setCurrentProductErrorStatus: (state, action) => {
      const { error } = action.payload;
      state.isCurrentProductError = Boolean(error);
    },
  },
});

export const { setCurrentProduct, setCurrentProductErrorStatus } =
  currentProductSlice.actions;
export const currentProductSliceReducer = currentProductSlice.reducer;
